// extracted by mini-css-extract-plugin
module.exports = {"G_7":"G_G_7__5Bz9c"};